import { OpeningHours } from 'lib-shared-types-api';
import { createContext, useContext } from 'react';

import type { AnnouncementItem } from 'components/shared/announcementPicker/adapters/announcementAdapter';

import type { IntervalsSelectProps } from '../intervalsSelect/intervalsSelect';

type CallbackWithId<TReturnValue> = (id: string) => TReturnValue;
export type ListItemContextType = {
  intervalsSelectProps: {
    errors: IntervalsSelectProps['errors'][];
    onChange: CallbackWithId<IntervalsSelectProps['onChange']>;
    validate: (index: number) => IntervalsSelectProps['validate'];
  };
  onAudioMessageChange: CallbackWithId<
    (audioMessage: AnnouncementItem) => void
  >;
  onAudioMessageClear?: CallbackWithId<VoidFunction>;
  onAutoReplyChange: CallbackWithId<(templateId?: string) => void>;
  onAutoReplyClear: CallbackWithId<VoidFunction>;
  onDelete?: CallbackWithId<VoidFunction>;
  onOverriddenChange: (listItem: OpeningHours) => void;
};

export const ListItemContext = createContext<null | ListItemContextType>(null);

export const useListItemContext = (): ListItemContextType => {
  const context = useContext(ListItemContext);

  if (!context) {
    throw new Error('There is no context provided.');
  }

  return context;
};
